<template>
  <div class="alipay-page">
    <!-- 页面内容区 -->
    <div class="page-scroll-content">

      <!-- 头部状态 -->
      <div class="header-status">
        <div class="status-title">
          <img class="icon-warning"
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath fill='%23ff8f1f' d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'/%3E%3Cpath fill='%23ff8f1f' d='M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-384h48l-12 240h-24z'/%3E%3C/svg%3E"
            alt="待支付" />
          <!-- <span>待支付 ({{ orderInfo.plateNo }})</span> -->
          {{ orderInfo.outSerialNo }} <span class="copy-btn" @click="copyOrderNo">📄</span>
        </div>
        <!-- <div class="order-no">
          {{ orderInfo.outSerialNo }} <span class="copy-btn" @click="copyOrderNo">📄</span>
        </div> -->
      </div>

      <!-- 订单主卡片 -->
      <div class="card order-card">
        <div class="park-header">
          <div class="park-name">
            <span class="icon-park">P</span>
            <strong>{{ orderInfo.parkingName }}</strong>
          </div>
          <div class="park-duration">
            {{ isExited ? '停留' : '已停车' }}：{{ orderInfo.parkedMinutes }}分钟
          </div>
        </div>

        <!-- 停车时间线 -->
        <div class="timeline-container">
          <div class="timeline-item">
            <div class="dot line-down"></div>
            <div class="timeline-content">
              <span class="label">入</span>入场 {{ orderInfo.inTime }}
            </div>
          </div>
          <div class="timeline-item">
            <div class="dot" :class="{ 'line-down': !isExited }"></div>
            <div class="timeline-content">
              <span class="label">出</span>
              <template v-if="isExited">出场 {{ orderInfo.outTime }}</template>
              <span v-else class="timeline-empty">尚未出场，离场后更新</span>
            </div>
          </div>
          <!-- <div class="timeline-item">
            <div class="dot"></div>
            <div class="timeline-content">
              <span class="label">出</span>离场后更新
            </div>
          </div> -->
        </div>

        <!-- 提示语 (未报错前显示) -->
        <!-- <div v-if="!isSubmitted" class="tip-box">
          <span class="icon-bulb">💡</span> 当前已入场，可能处于免费时段，中途或离场时（可长按下滑更新计费）
        </div> -->

        <!-- 费用信息 (未报错前显示) -->
        <div v-if="!isSubmitted" class="price-row">
          <div class="price-item">
            <span class="price-label">已支付</span>
            <span class="price-value">{{ orderInfo.paidAmount }}</span>
          </div>
          <div class="price-divider"></div>
          <div class="price-item">
            <span class="price-label">总金额</span>
            <span class="price-value total">￥{{ orderInfo.totalAmount }}</span>
          </div>
        </div>
      </div>

      <!-- 未提交报错时的区块 -->
      <template v-if="!isSubmitted">
        <!-- 优惠券 -->
        <!-- <div class="card cell-row">
          <span>优惠券</span>
          <span class="cell-value">暂无可用优惠券 &gt;</span>
        </div> -->
        <!-- 反馈入口 -->
        <div class="card cell-row action-row" @click="showModal = true">
          <span class="text-red">订单有疑问，点击这里进行反馈</span>
          <span class="icon-arrow">∨</span>
        </div>
      </template>

      <!-- 已提交报错后的区块 -->
      <template v-else>
        <div class="card submitted-card">
          <h3 class="submitted-title">订单已报错处理</h3>
          <p class="submitted-desc">如需缴费请您前往人工收费处</p>
        </div>
      </template>

    </div>

    <!-- 底部操作栏 -->
    <!-- <div class="bottom-bar">
      <button 
        class="btn-primary" 
        :class="{ 'btn-disabled': isSubmitted }"
        @click="handleMainAction"
      >
        {{ isSubmitted ? '已报错' : '原价支付' }}
      </button>
    </div> -->

    <!-- 异常反馈弹窗 (Bottom Sheet) -->
    <div class="modal-overlay" v-show="showModal" @click="showModal = false"></div>
    <div class="modal-content" :class="{ 'modal-show': showModal }">
      <div class="modal-header">
        <span class="modal-title">异常订单反馈</span>
        <span class="modal-close" @click="showModal = false">✕</span>
      </div>

      <div class="modal-body">
        <div class="warning-box">
          反馈成功后，本次订单将关闭，请勿重复反馈
        </div>

        <div class="radio-group-title">请选择异常类型</div>
        <div class="radio-item" v-for="item in feedbackTypes" :key="item.value" @click="feedbackType = item.value">
          <span>{{ item.label }}</span>
          <div class="radio-circle" :class="{ 'active': feedbackType === item.value }"></div>
        </div>

        <button class="btn-submit" :class="{ 'btn-submit-active': feedbackType !== '' }" @click="submitFeedback">
          提交
        </button>
      </div>


    </div>
  </div>
</template>

<script>
// 接口预留：后续补上具体的 API 引入
import { latestRecord, submitOrderFeedback } from '@/api/coupon/orderFeedback';
import { getRecordByPlateNo } from '@/api/coupon/platePay';
export default {
  name: "AlipayOrderFeedback",
  data() {
    return {
      isSubmitted: false, // 是否已经提交过异常
      showModal: false, // 控制弹窗显示
      feedbackType: "", // 选中的异常类型枚举值

      // 异常类型枚举
      feedbackTypes: [
        { value: 'PLATE_USER_FEEDBACK_ERROR', label: '车牌识别有误' },
        { value: 'CROSS_REGION_TRIP_BLOCK', label: '提示车辆异地，但并非我的车辆' },
        { value: 'EXIT_SYNC_UNABLE', label: '我已离场，但订单无法自动结束' },
        { value: 'VEHICLE_EXITED_STILL_CHARGING', label: '我已离场，订单仍在计时收费' },
        { value: 'EXIT_SYNC_ABLE', label: '我已离场，但订单未同步结束' },
        { value: 'NO_ORDER_RECEIVED', label: '收到停车通知，却查不到对应订单' },
        { value: 'CHARGE_FLAG_INACCURATE', label: '免费/收费标识不准确' },
        { value: 'BILLING_RULE_ERROR', label: '计费规则有误或不全' },
        { value: 'OTHER', label: '其他问题' }
      ],

      plateNumber: "", // 由上一页（异常反馈查询）传入的车牌号
      isLoading: false, // 页面数据加载状态

      // 页面数据（接口返回后回填）
      orderInfo: {
        plateNo: "",
        orderNo: "",
        parkName: "",
        duration: "",
        entryTime: "",
        amount: ""
      }
    };
  },
  computed: {
    // 车辆是否已出场：有出场时间即视为已出场
    isExited() {
      return !!this.orderInfo.outTime;
    }
  },
  created() {
    // 接收上一页通过路由 query 传入的车牌号
    this.plateNumber = this.$route.query.plateNumber || "";

    // 携带车牌号拉取页面所需信息
    this.getOrderInfo();
  },
  methods: {
    // 获取页面展示信息（接口预留，后续补上具体实现）
    getOrderInfo() {
      if (!this.plateNumber) {
        this.$weui.alert('缺少车牌号参数');
        return;
      }

      this.isLoading = true;

      // TODO: 待接入后端接口
      latestRecord({ plateNumber: this.plateNumber }).then(res => {
        this.isLoading = false;
        if (res.code === 200) {
          this.orderInfo = { ...res.data };
          // 如需判断是否已提交过异常
          this.isSubmitted = res.data.feedbackReported;
        }
      }).catch(() => {
        this.isLoading = false;
      });

      // ---- 临时占位：接口未接入前，先把车牌号回填到展示数据中 ----
      this.orderInfo.plateNo = this.plateNumber;
      this.isLoading = false;
    },

    copyOrderNo() {
      // 复制订单号逻辑，可接入原生或使用 clipboard API
      this.$toast && this.$toast('复制成功');
    },
    handleMainAction() {
      if (this.isSubmitted) return;
      // 唤起正常支付流程
      console.log('发起支付请求');
    },
    submitFeedback() {
      if (!this.feedbackType) return;


      submitOrderFeedback({
        plateNumber: this.orderInfo.plateNumber,
        outSerialNo: this.orderInfo.outSerialNo,
        parkinglotId: this.orderInfo.parkinglotId,
        feedbackType: this.feedbackType
      }).then(res => {
        if (res.code === 200) {
          this.isSubmitted = true;
          this.showModal = false;
          this.$weui.toast(res.msg, { duration: 2000 });
        }
      });

    },
    contactService() {
      console.log('拨打客服电话或跳转客服页面');
    }
  }
};
</script>
<style lang="stylus" scoped>
// 变量定义 (Stylus 语法使用 = 赋值)
$bg-color = #f5f5f5;
$blue-alipay = #1677ff;
$text-main = #333333;
$text-sub = #999999;
$border-color = #eeeeee;

.alipay-page {
  width: 100%;
  height: 100vh;
  background-color: $bg-color;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow: hidden;
}

.page-scroll-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

/* 头部状态 */
.header-status {
  padding: 10px 0 20px;
  .status-title {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    color: #ff8f1f;
    margin-bottom: 8px;
    
    .icon-warning {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
  .order-no {
    font-size: 13px;
    color: $text-sub;
    display: flex;
    align-items: center;
    .copy-btn {
      margin-left: 6px;
      font-size: 12px;
      color: $blue-alipay;
      cursor: pointer;
    }
  }
}

/* 通用卡片 */
.card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

/* 订单信息卡片 */
.order-card {
  .park-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    
    .park-name {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: $text-main;
      .icon-park {
        background: #333;
        color: #fff;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin-right: 8px;
      }
    }
    .park-duration {
      font-size: 13px;
      color: $text-main;
    }
  }

  .timeline-container {
    padding-left: 8px;
    margin-bottom: 20px;
    
    .timeline-item {
      position: relative;
      padding-left: 20px;
      padding-bottom: 20px;
      
      &:last-child {
        padding-bottom: 0;
      }

      .dot {
        position: absolute;
        left: 0;
        top: 2px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #d8d8d8;
        
        &.line-down::after {
          content: '';
          position: absolute;
          left: 2px;
          top: 10px;
          bottom: -16px;
          width: 1px;
          background: #e8e8e8;
        }
      }

            .timeline-content {
        font-size: 14px;
        color: $text-sub;
        display: flex;
        align-items: center;
        
        .label {
          color: $text-main;
          margin-right: 8px;
        }

        .timeline-empty {
          color: $text-sub;
          opacity: 0.7;
        }
      }
    }
  }

  .tip-box {
    background: #f6ffed;
    color: #52c41a;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.5;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    
    .icon-bulb {
      margin-right: 6px;
    }
  }

  .price-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-weight: bold;
    
    .duration {
      font-size: 14px;
      color: $text-main;
    }
    .amount {
      font-size: 20px;
      color: #ff8f1f;
    }
  }
}

/* 单元格行 (优惠券、反馈) */
.cell-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: $text-main;
  
  .cell-value {
    color: $text-sub;
  }
}
.action-row {
  justify-content: space-between;
  cursor: pointer;
  
  .text-red {
    color: #ff4d4f;
    font-size: 14px;
  }
  .icon-arrow {
    color: $text-sub;
  }
}

/* 提交报错后的卡片 */
.submitted-card {
  text-align: center;
  padding: 40px 0;
  
  .submitted-title {
    font-size: 18px;
    color: $text-main;
    margin-bottom: 8px;
  }
  .submitted-desc {
    font-size: 14px;
    color: $text-sub;
  }
}

/* 底部操作栏 */
.bottom-bar {
  background: #ffffff;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  
  .btn-primary {
    width: 100%;
    height: 44px;
    background: $blue-alipay;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    
    &.btn-disabled {
      background: #c3d9ff;
      color: #ffffff;
      opacity: 0.8;
      pointer-events: none;
    }
  }
}

/* === 弹窗样式 === */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 100;
}

.modal-content {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  z-index: 101;
  transform: translateY(100%);
  transition: transform 0.3s ease-out;
  padding-bottom: env(safe-area-inset-bottom);
  
  &.modal-show {
    transform: translateY(0);
  }

  .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid $border-color;
    position: relative;
    
    .modal-title {
      font-size: 16px;
      font-weight: bold;
      color: $text-main;
    }
    
    .modal-close {
      position: absolute;
      right: 16px;
      font-size: 18px;
      color: $text-sub;
      padding: 4px;
      cursor: pointer;
    }
  }

  .modal-body {
    padding: 20px 16px;
    
    .warning-box {
      background: #e6f0ff;
      color: #1677ff;
      padding: 12px;
      border-radius: 8px;
      font-size: 13px;
      line-height: 1.5;
      margin-bottom: 24px;
    }
    
    .radio-group-title {
      font-size: 15px;
      color: $text-sub;
      margin-bottom: 12px;
    }

    .radio-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid $border-color;
      font-size: 16px;
      color: $text-main;
      
      .radio-circle {
        width: 20px;
        height: 20px;
        border: 1px solid #d9d9d9;
        border-radius: 50%;
        position: relative;
        box-sizing: border-box;
        transition: all 0.2s;
        
        &.active {
          border-color: $blue-alipay;
          background-color: $blue-alipay;
          &::after {
            content: '';
            position: absolute;
            left: 6px;
            top: 2px;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
          }
        }
      }
    }

    .btn-submit {
      width: 100%;
      height: 44px;
      margin-top: 30px;
      background: #cce0ff;
      color: #ffffff;
      border: none;
      border-radius: 22px;
      font-size: 16px;
      font-weight: bold;
      transition: background 0.3s;
      
      &.btn-submit-active {
        background: $blue-alipay;
      }
    }
  }

  .modal-footer {
    text-align: center;
    padding-bottom: 20px;
    
    a {
      font-size: 13px;
      color: $text-sub;
      text-decoration: none;
    }
  }
}
</style>